import { Component } from '@angular/core';

@Component({
  selector: 'app-arrow-right',
  imports: [],
  template: `<svg
  width="24"
  height="24"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.6889 17.1672C11.6027 17.1676 11.5172 17.1508 11.4376 17.1178C11.3579 17.0847 11.2857 17.0361 11.2251 16.9747C11.1022 16.8517 11.0332 16.6849 11.0332 16.511C11.0332 16.3371 11.1022 16.1703 11.2251 16.0472L16.0114 11.261L11.2251 6.47472C11.1092 6.35032 11.0461 6.18578 11.0491 6.01577C11.0521 5.84575 11.121 5.68354 11.2412 5.5633C11.3614 5.44307 11.5237 5.3742 11.6937 5.3712C11.8637 5.3682 12.0282 5.4313 12.1526 5.54722L17.4026 10.7972C17.5255 10.9203 17.5945 11.0871 17.5945 11.261C17.5945 11.4349 17.5255 11.6017 17.4026 11.7247L12.1526 16.9747C12.092 17.0361 12.0198 17.0847 11.9402 17.1178C11.8605 17.1508 11.7751 17.1676 11.6889 17.1672V17.1672Z"
    fill="white"
  />
  <path
    d="M16.939 11.917H4.68896C4.51492 11.917 4.348 11.8479 4.22493 11.7248C4.10186 11.6017 4.03271 11.4348 4.03271 11.2607C4.03271 11.0867 4.10186 10.9198 4.22493 10.7967C4.348 10.6736 4.51492 10.6045 4.68896 10.6045H16.939C17.113 10.6045 17.2799 10.6736 17.403 10.7967C17.5261 10.9198 17.5952 11.0867 17.5952 11.2607C17.5952 11.4348 17.5261 11.6017 17.403 11.7248C17.2799 11.8479 17.113 11.917 16.939 11.917Z"
    fill="white"
  />
</svg>
`
})
export class ArrowRightComponent {

}
